module.exports = __webpack_public_path__ + "img/i_es_m_01.4a12830e.svg";